import React from 'react';
import { Link } from 'react-router-dom';
import { useModal } from '../context/ModalContext';

const Navbar = () => {
    const { openContactModal } = useModal();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handleOpenModal = () => {
        setIsMenuOpen(false);
        openContactModal();
    };

    return (
        <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-rose-100">
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <Link to="/" className="flex items-center group transition-all duration-300">
                    <div className="mr-4 flex items-center justify-center h-14 w-14">
                        <img
                            src="/EA-logo-esteticas.png"
                            alt="Estéticas de Argentina Logo"
                            className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-110"
                        />
                    </div>
                    <div className="flex flex-col">
                        <span className="text-xl font-display font-bold bg-gradient-to-r from-rose-600 to-violet-800 bg-clip-text text-transparent leading-none">
                            Estéticas
                        </span>
                        <span className="text-xs uppercase tracking-[0.2em] text-gray-500 font-medium mt-1">
                            de Argentina
                        </span>
                    </div>
                </Link>

                <div className="hidden md:flex space-x-8">
                    <Link to="/" className="nav-link-premium font-medium">Inicio</Link>
                    <Link to="/categoria/medicina-estetica" className="nav-link-premium font-medium text-gray-600 hover:text-rose-600 transition-colors">Medicina Estética</Link>
                    <Link to="/categoria/spa" className="nav-link-premium font-medium text-gray-600 hover:text-rose-600 transition-colors">Spa</Link>
                    <Link to="/categoria/salon" className="nav-link-premium font-medium text-gray-600 hover:text-rose-600 transition-colors">Salones</Link>
                </div>

                <div className="flex items-center space-x-4">
                    <button
                        onClick={openContactModal}
                        className="hidden sm:block btn-premium-secondary text-sm"
                    >
                        Anunciar Centro
                    </button>

                    {/* Mobile Menu Toggle */}
                    <button
                        onClick={toggleMenu}
                        className="md:hidden p-2 text-gray-700 hover:bg-rose-50 rounded-xl transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {isMenuOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="md:hidden bg-white border-b border-rose-100 animate-slide-down">
                    <div className="container mx-auto px-6 py-6 flex flex-col space-y-4">
                        <Link to="/" onClick={toggleMenu} className="text-lg font-bold text-slate-900 border-b border-slate-50 pb-2">Inicio</Link>
                        <Link to="/categoria/medicina-estetica" onClick={toggleMenu} className="text-lg font-medium text-slate-600 border-b border-slate-50 pb-2">Medicina Estética</Link>
                        <Link to="/categoria/spa" onClick={toggleMenu} className="text-lg font-medium text-slate-600 border-b border-slate-50 pb-2">Spa</Link>
                        <Link to="/categoria/salon" onClick={toggleMenu} className="text-lg font-medium text-slate-600 border-b border-slate-50 pb-2">Salones</Link>

                        <button
                            onClick={handleOpenModal}
                            className="w-full bg-gradient-to-r from-rose-500 to-violet-600 text-white font-bold py-4 rounded-xl shadow-lg shadow-rose-200"
                        >
                            Anunciar mi Centro
                        </button>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
